var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:({
    content: _vm.tooltipDate,
    appendToBody: true,
  }),expression:"{\n    content: tooltipDate,\n    appendToBody: true,\n  }"}]},[_vm._v(_vm._s(_vm.displayDate))])}
var staticRenderFns = []

export { render, staticRenderFns }